<template>
  <span class="gt-flag-option" :style="{ paddingLeft: depth * 1.25 + 'rem' }">
    <span
      class="gt-flag-option__dot"
      :class="{ 'gt-flag-option__dot--none': !dotColor }"
      :style="dotColor ? { backgroundColor: dotColor } : undefined"
    ></span>
    <span class="gt-flag-option__text">{{ label }}</span>
  </span>
</template>

<script>
/**
 * Opción de un selector de banderas: la sangría de su nivel y el punto de su color,
 * como la muestra el editor de la lista de banderas (#422).
 */
import { normalizeHexColor } from "@/utils/listItemColor";

export default {
  name: "FlagOptionLabel",
  props: {
    label: { type: String, default: "" },
    color: { type: String, default: "" },
    /** Nivel en el árbol de la lista (0 = raíz). */
    depth: { type: Number, default: 0 },
  },
  computed: {
    dotColor() {
      return normalizeHexColor(this.color) || "";
    },
  },
};
</script>

<style scoped>
.gt-flag-option {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  min-width: 0;
}

.gt-flag-option__dot {
  flex-shrink: 0;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  border: 1px solid rgba(0, 0, 0, 0.25);
}

.gt-flag-option__dot--none {
  border-style: dashed;
  border-color: #adb5bd;
}

.gt-flag-option__text {
  white-space: normal;
  word-break: break-word;
}
</style>
